import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptArizona = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Massachusetts Non-Profit State Filing Requirements & Deadlines  "
          description="Learn Massachusetts’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state. "
          keywords=" "
          canonical="nonprofit-taxes/massachusetts-state-filing-requirements/"
          // jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-ma-landing-img.webp" />
                <source srcSet="/assets/images/state-ma-landing-img.png" />
                <img
                  src="/assets/images/state-ma-landing-img.png"
                  alt="Massachusetts State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Massachusetts State </span>
                </span>{' '}
                Filing
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                If you&apos;re operating a nonprofit in Massachusetts, you must
                stay compliant with{' '}
                <Hidden mdUp smDown>
                  {' '}
                  <br />
                </Hidden>{' '}
                state-specific filing and registration requirements.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=massachusetts`}
                  >
                    Get Started Now
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-ma-landing-img-sm.webp" />
                <source srcSet="/assets/images/state-ma-landing-img-sm.png" />
                <img
                  src="/assets/images/state-ma-landing-img-sm.png"
                  alt="Massachusetts State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in Massachusetts are required to complete several forms
            as part of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Attorney General Forms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Tax Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sec.state.ma.us/divisions/corporations/download/180art.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Articles of Organization
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sec.state.ma.us/divisions/corporations/download/180npcar.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Annual Report
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sec.state.ma.us/divisions/corporations/download/180amen.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Articles of Amendment
                              </Link>
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sec.state.ma.us/divisions/corporations/download//180ccorr.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Certificate of Correction
                              </Link>
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.mass.gov/info-details/online-charity-filing-portal"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Initial Charity Registration
                              </Link>
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.mass.gov/info-details/online-charity-filing-portal"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form PC (Annual Filing)
                              </Link>
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.mass.gov/doc/formpcffillablepdf/download"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form PC-F
                              </Link>
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.mass.gov/info-details/register-your-business-with-masstaxconnect"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Sales Tax Registration Portal
                              </Link>
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.mass.gov/doc/form-m-3-reconciliation-of-massachusetts-income-taxes-withheld-for-employers-0/download"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form M-3 - Reconciliation of Massachusetts
                                Income Taxes Withheld for Employers
                              </Link>
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1023 (Application for Recognition of
                                Exemption Under Section 501(c)(3) of the
                                Internal Revenue Code):
                              </span>{' '}
                              For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1024 (Application for Recognition of
                                Exemption Under Section 501(a) or Section 521 of
                                the Internal Revenue Code):
                              </span>{' '}
                              For other types of nonprofits.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form 990 (Return of Organization Exempt From
                                  Income Tax):
                                </span>
                              </Link>{' '}
                              Annual information return for <br /> tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Massachusetts nonprofits must meet key state filing
                requirements, overseen by the{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Attorney General’s Office (AGO) and the Secretary of the
                  Commonwealth:
                </span>
              </Typography>
              <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                <li>
                  <span style={{ fontWeight: 600 }}> Incorporation </span> -
                  File Articles of Organization with the Secretary of the
                  Commonwealth to establish the nonprofit.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Charitable Registration
                  </span>{' '}
                  – Register with the AGO’s online Charity Portal before
                  operating or soliciting donations{' '}
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> Annual Filing </span> –
                  Submit annual financial reports to the AGO detailing finances
                  and activities.{' '}
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> Tax Filings</span> – File
                  state tax documents with the Department of Revenue (DOR) if
                  required.
                </li>{' '}
                <li>
                  <span style={{ fontWeight: 600 }}> Amendments </span> – Report
                  changes to governing documents, leadership, or other key
                  details to state agencies.
                </li>{' '}
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-ma-img.webp" />
                <source srcSet="/assets/images/who-file-ma-img.png" />
                <img
                  src="/assets/images/who-file-ma-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  borderRadius: 5,
                  backgroundColor: '#fff',
                  maxWidth: 800,
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    To maintain tax-exempt status in{' '}
                    <span style={{ fontWeight: 600 }}> Massachusetts</span>,
                    organizations must:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li svg': { float: 'left', fontSize: 27 },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      File Form PC with the Massachusetts Attorney
                      General&apos;s Office (Non-Profit Organizations/Public
                      Charities Division).
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply for{' '}
                      <span style={{ fontWeight: 600 }}>
                        Sales Tax Exemption Certificate (ST-2)
                      </span>{' '}
                      to the Massachusetts Department of Revenue for exemption
                      from sales tax.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply for exemption via{' '}
                      <span style={{ fontWeight: 600 }}>Form 1023 or 1024</span>{' '}
                      for federal 501(c)(3) status.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply for{' '}
                      <span style={{ fontWeight: 600 }}>
                        state corporate excise tax exemption
                      </span>{' '}
                      via Form M-4.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Must register and renew with the{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Division of Public Charities
                      </span>{' '}
                      for fundraising.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in
                Massachusetts:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Annual Report
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on or before November 1st of each year
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Articles of Amendment
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due within 60 days of the vote adopting the amendment
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Article of Organization
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed before the non-profit entity can be
                          legally established.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Attorney General Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form PC (Annual Filing)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          4.5 months after the end of a charity&apos;s fiscal
                          year
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Initial Charity Registration
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Before soliciting or receiving funds as a public
                          charity incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Tax Forms Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 500,
                          }}
                        >
                          Form M-3 - Reconciliation of Massachusetts Income
                          Taxes Withheld for Employers
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          January 31
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=massachusetts`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Massachusetts, organizations
            must file the Articles of Organization and pay{' '}
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>{' '}
            the filing fee ($35 by mail, $41 if filing online or by fax).
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Formation of a Non-Profit Corporation
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    With the Secretary of the Commonwealth: File Articles of
                    Organization and pay the required fee.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Appoint a Registered Agent
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    A registered agent is responsible for receiving legal and
                    official notices on behalf of your organization.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Obtaining an EIN
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    After incorporating with the state, you will need to obtain
                    an Employer Identification Number (EIN) from the IRS.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Initial Charity Registration (Attorney General&apos;s
                    Office)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Registration with the AGO is required before the
                    organization can commence operations or begin soliciting
                    funds within Massachusetts.
                  </Typography>
                  <Typography variant="body1">Attach copies of:</Typography>
                  <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                    <li>Articles of Organization </li>
                    <li>Bylaws </li>
                    <li>IRS Determination Letter (if available) </li>
                    <li>List of officers and directors </li>
                  </Box>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Applying for Federal Tax-Exempt Status
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    File Form 1023 or Form 1023-EZ, along with the required
                    filing fee.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Filing the Annual Report
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Domestic non-profit corporations must file their Annual
                    Report with the Corporations Division by November 1st each
                    year.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Filing Form PC and Attachments
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Registered charities are required to file Form PC annually
                    through the AGO&apos;s online Charity Portal.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Filing IRS Form 990
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Tax-exempt organizations must file the appropriate IRS Form
                    990 series return annually with the Internal Revenue
                    Service. The deadline is generally the 15th day of the 5th
                    month after the end of your fiscal year.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Keep Corporate Records
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Maintain proper corporate records, meeting minutes, and
                    financial records as required by Massachusetts nonprofit
                    corporation law.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Renew charitable organization
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    registration (if applicable) If your nonprofit solicits
                    donations, renew your charitable registration with the
                    appropriate state agency.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Trusted Compliance Platform for Nonprofits
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone simplifies nonprofit reporting with secure and compliant
          e-filing services.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=massachusetts`}
          >
            E-File Now!
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Who must register with the Massachusetts Attorney
                  General&apos;s Office?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    Most nonprofits, including charities soliciting funds or
                    owning assets, must register. Certain organizations, like
                    religious organizations, may be exempt.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What is the deadline for the annual Form PC filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The annual Form PC filing deadline in Massachusetts is 4.5
                      months after the end of a charity&apos;s fiscal year. If a
                      charity follows a calendar year, the deadline is typically
                      April 15th.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How do I obtain a copy of my organization&apos;s Articles
                  of Organization?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      You can obtain a copy from the{' '}
                      <Link
                        href="https://www.sec.state.ma.us/divisions/corporations/certificates/corporations-certified-copy-information.htm"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Massachusetts Secretary of the Commonwealth.
                      </Link>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can we use our federal tax exemption determination for
                  state tax purposes?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Federal 501(c)(3) status typically makes you eligible for
                      Massachusetts tax exemptions, but you must still apply
                      separately for specific state exemptions like sales tax.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. How do we update our organization&apos;s address or
                  leadership with the state?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      File a Certificate of Change of Address or Certificate of
                      Change of Directors/Officers with the Secretary of the
                      Commonwealth. You should also update this information on
                      your next Annual Report and Form PC.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://www.sec.state.ma.us/divisions/corporations/filing-by-subject/corporations/corporations-domestic-non-profit.htm"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Massachusetts Secretary of State - Corporations
                          Division
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://www.sec.state.ma.us/divisions/corporations/corporations.htm"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Massachusetts Secretary of the Commonwealth -
                          Corporations Division
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.mass.gov/orgs/the-attorney-generals-non-profit-organizationspublic-charities-division"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Massachusetts Attorney General&apos;s Office -
                          Non-Profit Organizations/Public Charities Division
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.mass.gov/orgs/massachusetts-department-of-revenue"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Massachusetts Department of Revenue - Nonprofits
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://massnonprofitnet.org/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Massachusetts Nonprofit Network
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Internal Revenue Services
                        </Link>
                      </li>{' '}
                    </Box>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{
                        // mt: 0,
                        // ml: { sm: 5, xs: 1 },
                        // mr: { sm: 8, xs: 1 },
                        // mb: { sm: 2, xs: 1 },
                        textAlign: 'left',
                        mb: 2,
                      }}
                    >
                      <b>Note -</b> Requirements and deadlines may change.
                      Organizations should verify current requirements with the
                      appropriate Massachusetts government agencies.
                    </Alert>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptArizona;
